import { FRONTEND_BASE_URL } from "src/redux/api/appConst";
import QRCode from "qrcode";

export const generateOrderQR = async (orderId: string) => {
  const verificationUrl = `${FRONTEND_BASE_URL}/supplement/orders/customer-info/${orderId}`;

  return await QRCode.toDataURL(verificationUrl, {
    width: 300,
    margin: 1,
  });
};
